import PropTypes from 'prop-types'

/**
 * @typedef {Object} OptiDriveScoreComponents
 * @property {number} [coastingScore]       - Coasting score.
 * @property {number} [constantSpeedScore]  - Constant speed score.
 * @property {number} [drivingScore]        - Driving score.
 * @property {number} [fuelScore]           - Fuel score.
 * @property {number} [greenSpeedScore]     - Green speed score.
 * @property {number} [highRevvingScore]    - High revving score.
 * @property {number} [idlingScore]         - Idling score.
 * @property {number} [speedingScore]       - Speeding score.
 */

export const optiDriveScoreComponentsPropType = PropTypes.shape({
    coastingScore: PropTypes.number,
    constantSpeedScore: PropTypes.number,
    drivingScore: PropTypes.number,
    fuelScore: PropTypes.number,
    greenSpeedScore: PropTypes.number,
    highRevvingScore: PropTypes.number,
    idlingScore: PropTypes.number,
    speedingScore: PropTypes.number
})
